// extracted by mini-css-extract-plugin
export default {"configurator-container":"Configurator_configurator-container__e603S","pricing-modal":"Configurator_pricing-modal__j+c+f"};